import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Box,
  Tooltip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { Delete, People } from '@mui/icons-material';

// import { formatDate } from '../../../../resources/functions';
import { RewardPartnerCompany } from '../../../../redux/slices/rewardPartnerCompanySlice';

interface Props {
  items: RewardPartnerCompany[];
  openPeopleDialog?: (partnerCompany: RewardPartnerCompany) => void;
  openDialog?: (partnerCompany: RewardPartnerCompany) => () => void;
  onDelete?: (_id: string) => void;
}

const cellStyles = {
  color: '#000000',
  fontWeight: 600
};

const RewardsPartnersTable = ({ items, openDialog, onDelete, openPeopleDialog }: Props) => {
  const theme = useTheme();
  
  return (
    <TableContainer sx={{ mt: 3 }} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ 
              backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
              color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#424242',
              fontWeight: 600
            }}>Зображення</TableCell>
            <TableCell sx={{ 
              backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
              color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#424242',
              fontWeight: 600
            }}>Назва</TableCell>
            {/* <TableCell sx={cellStyles}>Дата створення</TableCell>
            <TableCell sx={cellStyles}>Дата оновлення</TableCell> */}
            <TableCell sx={{ 
              backgroundColor: theme.palette.mode === 'dark' ? '#2A2A2A' : '#F5F5F5',
              color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#424242',
              fontWeight: 600
            }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(partnerCompany => {
            return (
              <TableRow
                hover
                key={partnerCompany._id}
                onClick={openDialog?.(partnerCompany)}
              >
                <TableCell>
                  {partnerCompany.logo?.startsWith('uploads/') ? (
                    <img
                      alt='icon-img'
                      style={{
                        maxWidth: 60,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        width: 60,
                        height: 60
                      }}
                      src={`/public/${partnerCompany.logo}`}
                    />
                  ) : (
                    'Немає логотипу'
                  )}
                </TableCell>
                <TableCell>{partnerCompany.name}</TableCell>
                {/* <TableCell>{formatDate(partnerCompany.createdAt)}</TableCell>
                <TableCell>{formatDate(partnerCompany.updatedAt)}</TableCell> */}
                <TableCell>
                  <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'flex-end' }}>
                    <Tooltip title='Люди'>
                      <IconButton
                        size='medium'
                        onClick={() => {
                          openPeopleDialog?.(partnerCompany);
                        }}
                        sx={{
                          bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : '#424242',
                          color: theme.palette.mode === 'light' ? '#616161' : '#FFF',
                          borderRadius: '8px',
                          '&:hover': { bgcolor: theme.palette.mode === 'light' ? '#E0E0E0' : '#3A3A3A' }
                        }}
                      >
                        <People fontSize='small' />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title='Видалити'>
                      <IconButton
                        size='medium'
                        onClick={() => onDelete?.(partnerCompany._id)}
                        sx={{
                          bgcolor: theme.palette.mode === 'light' ? '#F5F5F5' : '#424242',
                          color: theme.palette.mode === 'light' ? '#616161' : '#FFF',
                          borderRadius: '8px',
                          '&:hover': { bgcolor: theme.palette.mode === 'light' ? '#E0E0E0' : '#3A3A3A' }
                        }}
                      >
                        <Delete fontSize='small' />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RewardsPartnersTable;
